import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, IconButton, ListItemIcon, Collapse } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './index.css';

export default function MenuNavegacionMobile() {
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [openSubmenus, setOpenSubmenus] = useState<{ [key: string]: boolean }>({});
    const [mail, setMail] = useState('')

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setMail(config.MAIL_INCIDENCIAS)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const toggleSubmenu = (titulo: string) => {
        setOpenSubmenus((prev) => {
            const newOpenSubmenus = { ...prev };
            Object.keys(newOpenSubmenus).forEach(key => {
                if (key !== titulo) {
                    newOpenSubmenus[key] = false;
                }
            });
            newOpenSubmenus[titulo] = !prev[titulo];
            return newOpenSubmenus;
        });
    };

    const subencabezado_elementos = [
        { ruta: '/aparcamientos', titulo: "APARCAMIENTOS" },
        {
            ruta: '',
            titulo: "INCIDENCIAS",
            subrutas: [
                { ruta: '/incidencias', titulo: "Consultar Incidencias" },
                { ruta: '/mailto', titulo: "Notificar Incidencia" },
            ],
        },
        { ruta: '/enlaces', titulo: "ENLACES" },
    ];

    const abrirCorreo = () => {
        window.location.href = `mailto:${mail}`;
    };

    useEffect(() => {
        if (isDrawerOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    }, [isDrawerOpen]);

    return (
        <>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                <MenuIcon sx={{ width: '50px' }} />
            </IconButton>
            <Drawer
                anchor="left"
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                classes={{ paper: 'drawer-root' }}
            >
                <List>
                    {subencabezado_elementos.map((ele) => (
                        <React.Fragment key={ele.titulo}>
                            <ListItem button onClick={() => ele.subrutas ? toggleSubmenu(ele.titulo) : setDrawerOpen(false)}>
                                {ele.subrutas ? <ListItemText primary={ele.titulo} /> : <Link className='link-subruta' to={ele.ruta}><ListItemText primary={ele.titulo} /></Link>}
                                {ele.subrutas && (openSubmenus[ele.titulo] ? <KeyboardArrowDownIcon sx={{ width: '20px' }} /> : <ArrowForwardIosIcon sx={{ width: '15px' }} />)}
                            </ListItem>
                            {ele.subrutas && (
                                <Collapse in={openSubmenus[ele.titulo]} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {ele.subrutas.map((subruta) => (
                                            <ListItem button key={subruta.titulo} onClick={subruta.ruta === '/mailto' ? abrirCorreo : toggleDrawer(false)}>
                                                <ListItemText>
                                                    {subruta.ruta === '/mailto' ? (
                                                        <span className='link-subruta'  style={{display: 'flex'}}>
                                                            <ListItemIcon>
                                                                <ArrowForwardIosIcon sx={{ width: '15px' }} />
                                                            </ListItemIcon>
                                                            {subruta.titulo}
                                                        </span>
                                                    ) : (
                                                        <Link className='link-subruta' to={subruta.ruta} style={{display: 'flex'}}>
                                                            <ListItemIcon>
                                                                <ArrowForwardIosIcon sx={{ width: '15px' }} />
                                                            </ListItemIcon>
                                                            {subruta.titulo}
                                                        </Link>
                                                    )}
                                                </ListItemText>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Collapse>
                            )}
                        </React.Fragment>
                    ))}
                </List>
            </Drawer>
        </>
    );
}
